/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Price_Ent_CtaInputs */

const en_mk_price_ent_cta = /** @type {(inputs: Mk_Price_Ent_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Talk to us`)
};

const id_mk_price_ent_cta = /** @type {(inputs: Mk_Price_Ent_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hubungi kami`)
};

/**
* | output |
* | --- |
* | "Talk to us" |
*
* @param {Mk_Price_Ent_CtaInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_price_ent_cta = /** @type {((inputs?: Mk_Price_Ent_CtaInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Price_Ent_CtaInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_price_ent_cta(inputs)
	return en_mk_price_ent_cta(inputs)
});